import { createFileRoute, redirect } from '@tanstack/react-router'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/cash-sales/new')({
  validateSearch: (search: Record<string, unknown>) => search,
  beforeLoad: ({ context, search }) => {
    if (!hasGrant(context.queryClient, 'accounting_cash_sale.create'))
      throw redirect({ to: '/accounting/sales-receipts', search })
    throw redirect({ to: '/accounting/sales-receipts/new', search })
  },
  component: () => null,
})
